export default __webpack_public_path__ + "6c0cc4e.png";